import { useState } from "react";
import { MirrorFeature, MirrorFeatures } from "@rastreabilidadebrasil/tageditor";
import MirrorHorizontal from "./MirrorHorizontal";
import MirrorVertical from "./MirrorVertical";

const Mirror: React.FunctionComponent = () => {
  const [mirrorFeature, setMirrorFeature] = useState<MirrorFeatures>();

  return (
    <MirrorFeature featureUpdate={(f) => setMirrorFeature(f)}>
      <MirrorHorizontal mirrorFeature={mirrorFeature} />
      <MirrorVertical mirrorFeature={mirrorFeature} />
    </MirrorFeature>
  );
};

export default Mirror;
